import { getScrollTop, scrollTo, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

class VechenBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.goToTop);
    scrollContainerMediaQuery.addEventListener('change', this.bindScroll);
    window.addEventListener('pageshow', this.scheduleUpdate);
    this.bindScroll();
    const cartBar = document.querySelector('.sticky-add-to-cart__bar');
    if (cartBar) {
      this.cartObserver = new ResizeObserver(([entry]) => {
        this.style.setProperty('--vechen-cart-height', `${Math.ceil(entry.target.getBoundingClientRect().height)}px`);
      });
      this.cartObserver.observe(cartBar);
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.goToTop);
    this.scrollTarget?.removeEventListener('scroll', this.scheduleUpdate);
    scrollContainerMediaQuery.removeEventListener('change', this.bindScroll);
    window.removeEventListener('pageshow', this.scheduleUpdate);
    this.cartObserver?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = null;
  }

  bindScroll = () => {
    this.scrollTarget?.removeEventListener('scroll', this.scheduleUpdate);
    this.scrollTarget = getScrollEventTarget();
    this.scrollTarget.addEventListener('scroll', this.scheduleUpdate, { passive: true });
    this.scheduleUpdate();
  };

  scheduleUpdate = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.button.hidden = getScrollTop() < 600;
    });
  };

  goToTop = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' });
    // Return keyboard focus to the header without interrupting the scroll.
    document.querySelector('#header-component .header-logo a, #header-component a.header-logo, #header-component a[href]')?.focus({ preventScroll: true });
  };
}

if (!customElements.get('vechen-back-to-top')) {
  customElements.define('vechen-back-to-top', VechenBackToTop);
}
